// @flow
/* eslint-disable react/no-danger */
import React from 'react';

const icon = {
    __html: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <path fill="#999" fill-rule="evenodd" d="M10 0c3.315 0 6 2.685 6 6s-2.685 6-6 6a5.899 5.899 0 0 1-3.204-.926l-4.518 4.537c-.26.26-.611.389-.945.389-.352 0-.685-.13-.944-.389a1.341 1.341 0 0 1 0-1.889l4.537-4.518A5.899 5.899 0 0 1 4 6c0-3.315 2.685-6 6-6zm0 10c2.204 0 4-1.796 4-4 0-2.204-1.796-4-4-4-2.204 0-4 1.796-4 4 0 2.204 1.796 4 4 4z"/>
    </svg>
`
};

export const IconGtSearch = () => <span dangerouslySetInnerHTML={icon} />;

export default IconGtSearch;
